import { Button, Select } from "@rio-cloud/rio-uikit";
import Dialog from "@rio-cloud/rio-uikit/Dialog";
import { useState } from "react";
import { BUSINESS_SEGMENTS, ICreateOperationPayload } from "@types";

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: (payload: ICreateOperationPayload) => void;
}

const segmentOptions = BUSINESS_SEGMENTS.map((segment) => ({
  id: segment,
  label: segment,
}));

const DialogCreateOperation = ({ show, onClose, onSave }: Props) => {
  const [nameError, setNameError] = useState("");
  const [segmentError, setSegmentError] = useState("");
  const [name, setName] = useState("");
  const [segment, setSegment] = useState("");

  const handleSubmit = () => {
    let hasError = false;

    if (!name.trim()) {
      setNameError("Nome da operacao e obrigatorio");
      hasError = true;
    } else {
      setNameError("");
    }

    if (!segment) {
      setSegmentError("Segmento de negocio e obrigatorio");
      hasError = true;
    } else {
      setSegmentError("");
    }

    if (hasError) return;

    onSave({
      name: name.trim(),
      segment,
    });

    setName("");
    setSegment("");
  };

  const handleClose = () => {
    onClose();
    setName("");
    setSegment("");
    setNameError("");
    setSegmentError("");
  };

  return (
    <Dialog
      show={show}
      title={<span className="text-medium text-size-16">Nova Operacao</span>}
      body={
        <div className="display-flex flex-column gap-15">
          <div className={`form-group ${nameError ? "has-feedback has-error" : ""}`}>
            <label htmlFor="inputName">
              <span>Nome da Operacao *</span>
            </label>
            <div className="input-group">
              <input
                id="inputName"
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Ex: Operacao SP-01"
              />
            </div>
            {nameError && (
              <>
                <span className="form-control-feedback rioglyph rioglyph-error-sign" />
                <span className="help-block">
                  <span>{nameError}</span>
                </span>
              </>
            )}
          </div>

          <div className={`form-group ${segmentError ? "has-feedback has-error" : ""}`}>
            <label htmlFor="inputSegment">
              <span>Segmento de Negocio *</span>
            </label>
            <Select
              id="inputSegment"
              placeholder="Selecione o segmento"
              options={segmentOptions}
              value={segment ? [segment] : []}
              onChange={(selected) => {
                if (selected) {
                  const selectedItem = selected as { id: string };
                  setSegment(selectedItem.id);
                } else {
                  setSegment("");
                }
              }}
            />
            {segmentError && (
              <span className="help-block">
                <span>{segmentError}</span>
              </span>
            )}
          </div>
        </div>
      }
      onClose={handleClose}
      footer={
        <div className="display-flex align-items-center justify-content-end gap-10 flex-wrap">
          <Button onClick={handleClose} className="width-150 rounded-small width-100pct-xs">
            Cancelar
          </Button>
          <Button onClick={handleSubmit} bsStyle={Button.PRIMARY} className="width-150 rounded-small width-100pct-xs">
            Salvar
          </Button>
        </div>
      }
      showCloseButton
      useOverflow
    />
  );
};

export default DialogCreateOperation;
